import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

export const ROW_HEIGHT = 52;

export const AddressRow = styled(Grid)`
  height: ${ROW_HEIGHT}px;
  align-content: center;
`;
export const AddressItem = styled(Grid)`
  border: 1px solid ${RoutalPalette.grey4};
  padding: 2px 12px;
`;
